package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.model.RecurringCostRule
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class GetRecurringCostRulesUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(ownerId: String): Result<List<RecurringCostRule>> {
        return workplaceRepository.getRecurringCostRules(ownerId)
    }
}
